<template>
  <div class="predict-box">
    <p class="title"><span>"</span>{{data.level1}}{{data.level2 ? '-' + data.level2 : ''}}{{data.level3 ? '-' + data.level3 : ''}}<span>"</span></p>
    <p class="subtitle">{{data.top_achievement}}</p>
    <div class="portrait-box">
      <img :src="data.img" alt="" class="user-image">
      <div class="tag" :class="['tag' + (index + 1)]" v-for="(item, index) in list" :key="index">{{item}}</div>
    </div>
    <p class="ps" @click="$emit('on-retry')">感觉不准？换一条求职路 ></p>
  </div>
</template>

<script>


  export default {
    name: "Predict",
    props:{
      data: {
        type: Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {
        list:[]
      }
    },
    created() {
      if(this.data.face_description){
        this.list = this.data.face_description.split("，").slice(0,3)
      }
    },
    watch:{
      'data.face_description'(value){
        if (value){
          this.list = value.split("，").slice(0,3)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.predict-box{
  padding: 24px 24px 24px 28px;
  position: relative;
  .title{
    text-align: center;
    font-size: 28px;
    font-weight: 800;
    color: #FFFFFF;
    span{
      font-size: 32px;
    }
    margin-bottom: 8px;
  }
  .subtitle{
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    line-height: 28px;
  }
  .portrait-box{
    width: 230px;
    height: 230px;
    opacity: 0.8;
    margin: 28px auto;
    background-image: url("https://files.wondercv.com/m/ai/portrait.png");
    background-size: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .user-image{
      width: 120px;
      height: 120px;
      border-radius: 50%;
      margin: 29px auto;
    }
    .tag{
      position: absolute;
      background: #250A66;
      box-shadow: 0px 0px 12px 0px #8857FF inset;
      border-radius: 4px;
      padding: 2px 8px;
      line-height: 20px;
      text-align: center;
      font-weight: 400;
      color: #FFFFFF;
    }
    .tag1{
      left: -17px;
      top: 23px;
    }
    .tag2{
      left: -36px;
      bottom: 27px;
    }
    .tag3{
      right: -36px;
      bottom: 59px;
    }

  }
  .ps{
    text-align: center;
    bottom: -4px;
    color: #7E53E8;
    font-size: 13px;
    font-weight: 400;
    position: absolute;
    left: 0;
    right: 0;
  }
}
</style>